// Slick slider specific code

;( function($) {

  let Slick = window.Slick || {};

  // Doc ready
  $(document).ready(function() {

    let nextArrowEl = '<button type="button" class="slick-next disable-default" aria-label="Palaa edelliseen karusellikuvaan" aria-hidden="true">&laquo;</button>',
        prevArrowEl = '<button type="button" class="slick-prev disable-default" aria-label="Mene seuraavaan karusellikuvaan" aria-hidden="true" >&raquo;</button>';

    $('.section--slider').each(function(index, item) {

      let $currentItem = $(item);
      // Tie everything to the hash id, so the paging etc. works no matter how many sliders
      let currentItemId = $currentItem.attr('id');
      let $currentSlider = $('#' + currentItemId);
      let $currentSliderSlick = $currentSlider.find('.eprogramme-slick-slider');
      let $pagingStatus = $currentSlider.find('.slider-paging-status');
      let $thisSwipeGuide = $currentItem.find('.swipe-icon');
      // Hidden at start just to be on the safe side, so let's enable it.
      $thisSwipeGuide.removeClass('hidden');

      // Function to remove the swipe guide
      // $thisSwipeGuide.on('click touchstart', function(e) {
      //   $(e.target).addClass('hidden');
      // });

      // Hook paging Status info - before setup
      $currentSliderSlick.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        let i = ( currentSlide ? currentSlide : 0 ) + 1;
        $pagingStatus.text(i + '/' + slick.slideCount);
      });

      // Function to remove the swipe guide on change
      $currentSliderSlick.on('swipe', function(event, slick, currentSlide, nextSlide) {
        $thisSwipeGuide.addClass('hidden');
      });

      $currentSliderSlick.slick({
        dots: false, //true,
        arrows: false,
        speed: 500,
        lazyLoad: 'ondemand',
        infinite: true,
        nextArrow: nextArrowEl,
        prevArrow: prevArrowEl,
      });

    });

  }); // .end Doc ready
} )(jQuery);
